module.exports = __webpack_public_path__ + "workspace/static/img/renewalManagerSeven.0e52955.png";